import React from 'react';
import { connect as connectFormik } from 'formik';
import { Icon } from '../../../../web.common';
import DatePicker from 'react-datepicker';
import Moment from 'moment';
import { DisplayDate } from '../../../items';

class EditDisablesBase extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  add(Disables) {
    this.setState({
      editing: Disables.length,
      editingFrom: Moment().format(),
      editingTo: Moment().format()
    });
  }

  startEditing(index, DisableFrom, DisableTo) {
    this.setState({
      editing: index,
      editingFrom: DisableFrom,
      editingTo: DisableTo
    });
  }

  edit(index, editingFrom, editingTo) {
    const { formik } = this.props;
    const { values, setFieldValue, setFieldTouched } = formik;
    const { Disables } = values;

    const edited = JSON.parse(JSON.stringify(Disables));
    edited[index].DisableFrom = editingFrom;
    edited[index].DisableTo = editingTo;
    setFieldValue('Disables', edited);
    setFieldTouched('Disables', true);
    this.setState({
      editing: null
    });
  }

  confirm() {
    const { formik } = this.props;
    const { editingFrom = '', editingTo = '' } = this.state;
    const { values, setFieldValue, setFieldTouched } = formik;
    const { Disables } = values;

    const newEntry = {
      DisableFrom: editingFrom,
      DisableTo: editingTo
    };
    const edited = JSON.parse(JSON.stringify(Disables));
    edited.push(newEntry);

    setFieldValue('Disables', edited);
    setFieldTouched('Disables', true);

    this.setState({
      editing: null
    });
  }

  remove(index) {
    const { formik } = this.props;
    const { values, setFieldValue, setFieldTouched } = formik;
    const { Disables } = values;

    const edited = JSON.parse(JSON.stringify(Disables));
    edited.splice(index, 1);

    setFieldValue('Disables', edited);
    setFieldTouched('Disables', true);
  }

  renderShowOpeningHourRow(disableFrom, disableTo, index) {
    const { editing } = this.state;

    return (
      <li>
        <span style={{ marginLeft: '5px' }}>
          <DisplayDate>{disableFrom}</DisplayDate>
          {' '}
          -
          {' '}
          <DisplayDate>{disableTo}</DisplayDate>
          {' '}
        </span>

        {editing ? (
          ''
        ) : (
          <span
            className='icon-edit'
            onClick={() => this.startEditing(index, disableFrom, disableTo)}
          >
            <Icon iconName='edit' />
          </span>
        )}
        {editing ? (
          ''
        ) : (
          <span className='icon-remove' onClick={() => this.remove(index)}>
            <Icon iconName='times' />
          </span>
        )}
      </li>
    );
  }

  renderAddOpeningHour() {
    const {
      props: { formik },
      state: { editingFrom = '', editingTo = '' }
    } = this;
    const { values } = formik;
    const { Disables } = values;

    const selectedFrom = editingFrom ? new Date(editingFrom) : null;
    const selectedTo = editingTo ? new Date(editingTo) : null;

    return (
      <li>
        <DatePicker
          key={`add-from-${Disables.length}`}
          className='editing-from'
          name={`editing-from-${Disables.length}`}
          style={{ width: '320px', display: 'inline-block' }}
          selected={selectedFrom}
          onChange={date =>
            this.setState({ editingFrom: Moment(date).format() })
          }
          showTimeSelect
          timeFormat='HH:mm'
          timeIntervals={15}
          timeCaption='time'
          dateFormat='MMMM d, yyyy h:mm aa'
        />

        <span> - </span>

        <DatePicker
          key={`add-to-${Disables.length}`}
          className='editing-to'
          name={`editing-to-${Disables.length}`}
          style={{ width: '320px', display: 'inline-block' }}
          selected={selectedTo}
          onChange={date =>
            this.setState({ editingTo: Moment(date).format() })
          }
          showTimeSelect
          timeFormat='HH:mm'
          timeIntervals={15}
          timeCaption='time'
          dateFormat='MMMM d, yyyy h:mm aa'
        />

        <span className='icon-confirm' onClick={() => this.confirm()}>
          <Icon className='true' iconName='check' />
        </span>

        <span
          className='icon-undo'
          onClick={() => this.setState({ editing: null })}
        >
          <Icon className='true' iconName='undo' />
        </span>
      </li>
    );
  }

  renderEditOpeningHourRow(index) {
    const { editingFrom = '', editingTo = '' } = this.state;

    const selectedFrom = editingFrom ? new Date(editingFrom) : null;
    const selectedTo = editingTo ? new Date(editingTo) : null;

    return (
      <li>
        <DatePicker
          key={`edit-from-${index}`}
          style={{ width: '320px', display: 'inline-block' }}
          selected={selectedFrom}
          onChange={date =>
            this.setState({ editingFrom: Moment(date).format() })
          }
          showTimeSelect
          timeFormat='HH:mm'
          timeIntervals={15}
          timeCaption='time'
          dateFormat='MMMM d, yyyy h:mm aa'
        />

        <span> - </span>

        <DatePicker
          key={`edit-to-${index}`}
          style={{ width: '320px', display: 'inline-block' }}
          selected={selectedTo}
          onChange={date =>
            this.setState({ editingTo: Moment(date).format() })
          }
          showTimeSelect
          timeFormat='HH:mm'
          timeIntervals={15}
          timeCaption='time'
          dateFormat='MMMM d, yyyy h:mm aa'
        />
        <span
          className='editing-confirm'
          onClick={() => this.edit(index, editingFrom, editingTo)}
        >
          <Icon className='icon-confirm' iconName='check' />
        </span>
        <span
          onClick={() => {
            this.setState({
              editing: null
            });
          }}
        >
          <Icon className='true' iconName='undo' />
        </span>
      </li>
    );
  }

  render() {
    const {
      props: { formik },
      state: { editing }
    } = this;
    const { values } = formik;
    const { Disables } = values;
    const isAddingNew = editing === Disables.length;

    return (
      <React.Fragment>
        <ul className='edit-opening-hours'>
          {Disables.map(({ DisableFrom, DisableTo }, index) =>
            (editing === index
              ? this.renderEditOpeningHourRow(index)
              : this.renderShowOpeningHourRow(DisableFrom, DisableTo, index))
          )}

          {editing ? (
            ''
          ) : (
            <span className='icon-add' onClick={() => this.add(Disables)}>
              <Icon className='true' iconName='plus' />
            </span>
          )}
          {!isAddingNew ? '' : this.renderAddOpeningHour()}
        </ul>
      </React.Fragment>
    );
  }
}

export const EditDisables = connectFormik(EditDisablesBase);